(function () {
  function styleAddToCart(btn) {
    if (!btn) return;
    btn.style.setProperty('background', '#ffffff', 'important');
    btn.style.setProperty('background-color', '#ffffff', 'important');
    btn.style.setProperty('color', '#121212', 'important');
    btn.style.setProperty('border', '2px solid #121212', 'important');
  }

  function styleBuyNow(btn) {
    if (!btn) return;
    btn.style.setProperty('background', '#121212', 'important');
    btn.style.setProperty('background-color', '#121212', 'important');
    btn.style.setProperty('color', '#ffffff', 'important');
    btn.style.setProperty('border', '2px solid #121212', 'important');
  }

  function hideDuplicateAtc() {
    // Botones "Agregar al carrito" duplicados inyectados por apps de terceros
    // (regalo gratis / kits / bundles) fuera del formulario real de producto.
    document.querySelectorAll('[id^="custom-atc-btn"]').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('.product__column-sticky button.button--full-width.button--primary').forEach(function (el) {
      if (!el.classList.contains('product-form__submit')) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function fixAll() {
    hideDuplicateAtc();
    document.querySelectorAll('[id^="ProductSubmitButton"]').forEach(styleAddToCart);
    document.querySelectorAll('[id^="BuyNowButton"]').forEach(styleBuyNow);
  }

  fixAll();
  document.addEventListener('DOMContentLoaded', fixAll);

  // Observamos unicamente el contenedor de producto (no todo el body) y
  // agregamos un debounce para evitar recalculos excesivos cuando otros
  // scripts (temporizadores, sliders, apps) actualizan el DOM constantemente.
  var debounceTimer = null;
  function scheduleFix() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fixAll, 150);
  }

  function startObserving() {
    var target = document.querySelector('.product') || document.body;
    var observer = new MutationObserver(function (mutations) {
      var needsFix = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' || m.type === 'childList') { needsFix = true; break; }
      }
      if (needsFix) scheduleFix();
    });
    observer.observe(target, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && (e.target.closest('[id^="ProductSubmitButton"]') || e.target.closest('[id^="BuyNowButton"]'))) {
      setTimeout(fixAll, 50);
      setTimeout(fixAll, 300);
    }
  });
})();
